import {  IconButton, Switch, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Card, Tables } from 'src/shared/components/index';
import { useNavigate } from 'react-router-dom';
import { UserData } from '../models';
import { I18N, ROLES } from 'src/shared/constants/constants';
 
import { useSelector} from 'react-redux';
import { FC, useState, useEffect } from 'react';
import { selectUserState } from 'src/auth/login/services/userSlice';
interface UserManagementTableProps {
  className?: string;
  inputLoginUserRole: string;
  handleEditIconClick(row: any): void;
  handleDeleteIconClick(row: any): void;
  handleSwitchIconClick(email: any): void;
  inputUserData: UserData[];
}

const UserManagementTable: FC<UserManagementTableProps> = ({
  handleEditIconClick,
  handleDeleteIconClick,
  handleSwitchIconClick,
  inputLoginUserRole,
  inputUserData
}) => {
  const { userData } = useSelector(selectUserState);
  const [userTableColumns, setuserTableColumns] = useState([]);
  const handleEditIconClickEvent = (row) => {
    handleEditIconClick(row);
  };

  const handleSwitchIconClickEvent = (row) => {
    handleSwitchIconClick(row);
  };

  const handleDeleteIconClickEvent = (row) => {
    handleDeleteIconClick(row);
  };
  const navigate = useNavigate();

  const { t } = useTranslation(I18N.DEFAULT);
  const columns: GridColDef[] = [
    {
      field: 'none',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.1
    },
    // {
    //   field: t('status'),
    //   sortable: false,
    //   flex: 1,
    //   renderCell: (params: GridRenderCellParams<any>) => {
    //     return (
    //       <>
    //         {((inputLoginUserRole === ROLES.TENANT_ADMIN ||
    //           inputLoginUserRole === ROLES.ADMIN_OPERATOR ||
    //           inputLoginUserRole === ROLES.SUPER_ADMIN) &&
    //           inputLoginUserRole !== ROLES.TENANT_OPERATOR &&
    //           params.row.id != userData.id) ||
    //         (params.row.role.id == ROLES.TENANT_OPERATOR &&
    //           params.row.id != userData.id) ? (
    //           <>
    //             <Tooltip title={t('enable-disable')} arrow>
    //               <Switch
    //                 checked={params.row.isEnabled}
    //                 disabled={params.row.id == userData.id}
    //                 onClick={() => handleSwitchIconClickEvent(params.row)}
    //               />
    //             </Tooltip>
    //           </>
    //         ) : (
    //           ''
    //         )}
    //       </>
    //     );
    //   }
    // },
    {
      field: 'name',
      sortable: true,
      headerName: t('name'),
      flex: 2.5,
      valueGetter: (params) => {
        return `${params.row.name || ''}`;
      }
    }
  ];
  const actionColumn: GridColDef = {
    field: t('actions'),
    sortable: false,
    width: 100,
    flex: 1,
    renderCell: (params: GridRenderCellParams<any>) => {
      return (
        <>
          <Tooltip title={t('delete')} arrow>
            <IconButton
              color="inherit"
              size="small"
              className="RecentOrderDeleteButton"
              onClick={() => handleDeleteIconClickEvent(params.row)}
            >
              <DeleteTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title={t('edit')} arrow>
            <IconButton
              aria-label="editUser"
              onClick={() => handleEditIconClickEvent(params.row)}
              className="RecentOrderEditButton ml-8"
              color="inherit"
              size="small"
            >
              <EditTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      );
    }
  };
  useEffect(() => {
    if (inputLoginUserRole === ROLES.TENANT_OPERATOR) {
      setuserTableColumns(columns);
    } else {
      setuserTableColumns([...columns, actionColumn]);
    }
  }, []);
  return (
    <>
      <Card className="mb-24">
        <Tables
          rows={inputUserData}
          columns={userTableColumns}
          checkboxSelection={false}
        />
      </Card>
    </>
  );
};

UserManagementTable.propTypes = {
  inputUserData: PropTypes.array.isRequired
};

UserManagementTable.defaultProps = {
  inputUserData: []
};

export default UserManagementTable;
